module.exports = __webpack_public_path__ + "img/alarm_on.eff68427.svg";